import React, { memo, RefObject } from 'react';

import VolumeMute from 'assets/images/volume-mute.svg';
import VolumeUp from 'assets/images/volume-up.svg';
import ButtonLink from 'components/button-link';
import Image from 'components/image';

interface IVolumeButton {
  innerRef: RefObject<HTMLButtonElement>;
  isMuted: boolean;
  onClick: () => void;
}

const VolumeButton: React.FC<IVolumeButton> = ({ innerRef, isMuted, onClick }) => {
  return (
    <ButtonLink innerRef={innerRef} className="volume-btn bottom-controls" onClick={onClick} >
      <div className="background" />
      <Image src={isMuted ? VolumeMute : VolumeUp} />
    </ButtonLink>
  );
};

export default memo(VolumeButton);
